﻿window.cObjetReservationServiceMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Service"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau service"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data == 'undefined' && objet.data == null) { txt = "Service" }
        else {
            txt = objet.data.nom
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-champagne-glasses'></i>");
    }

    this.mCreateNewService = function (idArticle, dataReservation, dataReservationHebergement, funcEnd) {
        var dataNew = objet.mGetNewData()
        dataNew.id_reservation = (dataReservation ? dataReservation.id_reservation : null)
        dataNew.id_reservation_hebergement = (dataReservationHebergement ? dataReservationHebergement.id_reservation_hebergement : null)
        dataNew.id_article = idArticle
        dataNew.puttc = objet.bddRef.getObjet("article", idArticle).objetMetier.mGetPUTTC((dataReservationHebergement ? dataReservationHebergement.date_fin : parametre.dateNow))
        dataNew.id_type_iteration_service = this.mGetParaidTypeIterationServiceForArticle(idArticle)
        if (dataNew.id_type_iteration_service > 1) dataNew.id_type_iteration_service = 1
        dataNew.id_type_plage_service = this.mGetParaidTypePlageServiceForArticle(idArticle)
        dataNew.qte = 0
        if (dataReservation) {
            //on est sur une réservation, on sauvegarde
            objet.bddRef.getObjet(dataNew).mSave(function (data) {
                funcEnd(dataNew)
            })
        } else {
            //on est sur un parametrage, on ne fait pas de sauvegarde
            funcEnd(dataNew)
        }
    }

    this.mUpdateResaServiceDate = function (lstValueDate, funcEnd, funcAll) {
        var lstDate = []
        lstValueDate.forEach(function (val) { lstDate.push({ dat: val.toFrenchDateTime() }) })
        var lstObjetToRemove = objet.bddRef.mGetArray("reservation_service_date").filter(function (o) { return o.id_reservation_service == objet.data.id_reservation_service })
        objet.bddRef.mAjaxCall({
            command: "savelstdateservice",
            id_reservation_service: objet.data.id_reservation_service,
            lst_date: lstDate
        }, function (data) {
            lstObjetToRemove.forEach(function (dataReservationServiceDate) {
                objet.bddRef.mDelItemData("reservation_service_date", dataReservationServiceDate)
            })
            if (funcEnd) funcEnd()
            //mRempliLstJour()
        }, function () {
            if (funcAll) funcAll()
            //dxLstJour.isDisabledAll(false)
        })
    }

    this.mGetParaidTypeIterationServiceForArticle = function (idArticle, valueToSave) {
        if (!objet.bddRef.utiCourantParaJson.parametre_general.reservation) objet.bddRef.utiCourantParaJson.parametre_general.reservation = {}
        if (typeof valueToSave != 'undefined') {
            objet.bddRef.utiCourantParaJson.parametre_general.reservation["type_iteration_service_article_" + idArticle] = valueToSave
            objet.bddRef.mSaveParaJsonUtilisateur();
        }
        if (typeof objet.bddRef.utiCourantParaJson.parametre_general.reservation["type_iteration_service_article_" + idArticle] != 'undefined') {
            return objet.bddRef.utiCourantParaJson.parametre_general.reservation["type_iteration_service_article_" + idArticle]
        } else { return 0 }
    }

    this.mGetParaidTypePlageServiceForArticle = function (idArticle, valueToSave) {
        if (!objet.bddRef.utiCourantParaJson.parametre_general.reservation) objet.bddRef.utiCourantParaJson.parametre_general.reservation = {}
        if (typeof valueToSave != 'undefined') {
            objet.bddRef.utiCourantParaJson.parametre_general.reservation["type_plage_service_article_" + idArticle] = valueToSave
            objet.bddRef.mSaveParaJsonUtilisateur();
        }
        if (typeof objet.bddRef.utiCourantParaJson.parametre_general.reservation["type_plage_service_article_" + idArticle] != 'undefined') {
            return objet.bddRef.utiCourantParaJson.parametre_general.reservation["type_plage_service_article_" + idArticle]
        } else { return 0 }
    }

    this.mGetParaidTypeQuantiteServiceForArticle = function (idArticle, valueToSave) {
        if (!objet.bddRef.utiCourantParaJson.parametre_general.reservation) objet.bddRef.utiCourantParaJson.parametre_general.reservation = {}
        if (typeof valueToSave != 'undefined') {
            objet.bddRef.utiCourantParaJson.parametre_general.reservation["type_quantite_service_article_" + idArticle] = valueToSave
            objet.bddRef.mSaveParaJsonUtilisateur();
        }
        if (objet.bddRef.utiCourantParaJson.parametre_general.reservation["type_quantite_service_article_" + idArticle]) {
            return objet.bddRef.utiCourantParaJson.parametre_general.reservation["type_quantite_service_article_" + idArticle]
        } else { return 3 }
    }

    this.mGetDataReservation = function () {
        return objet.bddRef.mGetArray("reservation").filter(function (o) { return o.id_reservation == objet.data.id_reservation })[0]
    }
    this.mGetDataReservationHebergement = function () {
        return objet.bddRef.mGetArray("reservation_hebergement").filter(function (o) { return o.id_reservation_hebergement == objet.data.id_reservation_hebergement })[0]
    }
    this.mGetLstDataReservationServiceDate = function () {
        return objet.bddRef.mGetArray("reservation_service_date").filter(function (o) { return o.id_reservation_service == objet.data.id_reservation_service })
    }
    this.mGetDataArticle = function () {
        return objet.bddRef.mGetArray("article").filter(function (o) { return o.id_article == objet.data.id_article })[0]
    }

    //retourne la liste des objets date du reservation service
    this.mGetLstDateNbReservationService = function () {
        var lstDateNbResaService = []
        if (objet.data.id_reservation_hebergement) {
            //sur hébergement
            var dataResaHeberg = this.mGetDataReservationHebergement()
            var lstDate = objet.bddRef.getObjet(dataResaHeberg).objetMetier.mGetLstJourneesService()
            switch (parseInt(objet.data.id_type_plage_service)) {
                case 0://inconnu
                    //si on a pas de service
                    //on compte tous les jours + journées de départ
                    ////on compte les nuités et on enlève la dernière journée
                    //lstDate.splice(lstDate.length - 1, 1)
                    break;
                case 1://matin
                    lstDate.splice(0, 1)
                    break;
                case 2://midi
                    lstDate.splice(0, 1)
                    lstDate.splice(lstDate.length - 1, 1)
                    break;
                case 3://soir
                    lstDate.splice(lstDate.length - 1, 1)
                    break;
            }
            lstDate.forEach(function (dat) {
                var objCl = new cDateNbReservationService(objet.bddRef, dat, objet.data)
                objCl.lstDataReservationHebergement.push(dataResaHeberg)
                lstDateNbResaService.push(objCl)
            })
        } else {
            //sur résa
            //on gére le cas où on est sur un service parametre
            ////ne sert plus
            //var dataReservation = this.mGetDataReservation()
            //if (dataReservation) {
            //    //on est sur une résa
            //    objet.bddRef.getObjet(dataReservation).objetMetier.mGetLstDataReservationHebergement().forEach(function (dataResaHeberg) {
            //        var lstDate = objet.bddRef.getObjet(dataResaHeberg).objetMetier.mGetLstJourneesService()
            //        switch (parseInt(objet.data.id_type_plage_service)) {
            //            case 0://inconnu
            //                //si on a pas de service
            //                //on compte les nuités et on enlève la dernière journée
            //                lstDate.splice(lstDate.length - 1, 1)
            //                break;
            //            case 1://matin
            //                lstDate.splice(0, 1)
            //                break;
            //            case 2://midi
            //                lstDate.splice(0, 1)
            //                lstDate.splice(lstDate.length - 1, 1)
            //                break;
            //            case 3://soir
            //                lstDate.splice(lstDate.length - 1, 1)
            //                break;
            //        }
            //        lstDate.forEach(function (dat) {
            //            var itemDateNbResaService = lstDateNbResaService.filter(function (o) { return o.date.toDDMMAA() == dat.toDDMMAA() })[0]
            //            if (!itemDateNbResaService) {
            //                itemDateNbResaService = new cDateNbReservationService(objet.bddRef, dat, objet.data)
            //                lstDateNbResaService.push(itemDateNbResaService)
            //            }
            //            itemDateNbResaService.lstDataReservationHebergement.push(dataResaHeberg)
            //        })
            //    })
            //} else {
                //on est sur un paramètrage
                lstDateNbResaService = []
            //}
        }
        lstDateNbResaService = lstDateNbResaService.sort(function (o1, o2) { return o1.date - o2.date })
        return lstDateNbResaService
    }

    this.mGetLstDateNbReservationServiceActive = function () {
        switch (parseInt(objet.data.id_type_iteration_service)) {
            //case 0: //1fois
            //    lstDataDate = [this.mGetLstAllDataNbDateService()[0]]
            //    break;
            case 0: //Toutes les nuités
                return this.mGetLstDateNbReservationService()
                break;
            case 1: //selection dates
                var lstSelected = this.mGetLstJourneesServiceSelected()
                return this.mGetLstDateNbReservationService().filter(function (item) {
                    return lstSelected.filter(function (o) { return o.toDDMMAA() == item.date.toDDMMAA() }).length > 0
                })
                break;
        }
    }
    //retourne les groupes de date identique
    this.mGetLstGrpDateNbReservationService = function () {
        var lstGrpDateNbReservationService = [];
        var currentGroup = null;
        var prevDate = null;
        var prevQteCompare = null;

        this.mGetLstDateNbReservationServiceActive().forEach(function (itemDateNbResaService) {
            var currentDate = new Date(itemDateNbResaService.date);
            var currentQteCompare = itemDateNbResaService.mGetQteCompare()

            if (prevDate === null) {
                // premier élément
                var grp = new cGrpDateNbReservationService(objet.bddRef, objet.data, lstGrpDateNbReservationService)
                grp.lstDateNbReservationService.push(itemDateNbResaService)
                currentGroup = grp;
            } else {
                var diffTime = currentDate - prevDate;
                var diffDays = diffTime / (1000 * 60 * 60 * 24);

                if (diffDays === 1 && currentQteCompare == prevQteCompare) {
                    // jour suivant => même groupe
                    currentGroup.lstDateNbReservationService.push(itemDateNbResaService);
                } else {
                    // trou => nouveau groupe
                    lstGrpDateNbReservationService.push(currentGroup);
                    var grp = new cGrpDateNbReservationService(objet.bddRef, objet.data, lstGrpDateNbReservationService)
                    grp.lstDateNbReservationService.push(itemDateNbResaService)
                    currentGroup = grp;
                }
            }

            prevDate = currentDate;
            prevQteCompare = currentQteCompare
        });

        // ajouter le dernier groupe
        if (currentGroup) {
            lstGrpDateNbReservationService.push(currentGroup);
        }
        return lstGrpDateNbReservationService
    }

    //retourne la liste des dates sélectionnées (en cas de choix de date)
    this.mGetLstJourneesServiceSelected = function () {
        var lstDate = []
        this.mGetLstDataReservationServiceDate().forEach(function (resaDate) {
            lstDate.push(resaDate.dat)
        })
        return lstDate
    }

    this.mGetNbAdulte = function () {
        if (objet.data.id_reservation_hebergement) {
            return this.mGetDataReservationHebergement().nb_adulte
        } else {
            //on gére le cas où on est sur un service parametre
            var dataReservation = this.mGetDataReservation()
            return (dataReservation ? objet.bddRef.getObjet(dataReservation).objetMetier.mGetNbAdulte() : 0)
        }
    }
    this.mGetNbEnfant = function () {
        if (objet.data.id_reservation_hebergement) {
            return this.mGetDataReservationHebergement().nb_enfant
        } else {
            //on gére le cas où on est sur un service parametre
            var dataReservation = this.mGetDataReservation()
            return (dataReservation ? objet.bddRef.getObjet(dataReservation).objetMetier.mGetNbEnfant() : 0)
        }
    }

    //this.mGetQuantiteTotalService = function (lstGrpDate) {
    //    var qte = 0
    //    if (!lstGrpDate) lstGrpDate = this.mGetLstSelectDataNbDateService()
    //    lstGrpDate.forEach(function (item) {
    //        switch (parseInt(objet.data.id_type_quantite)) {
    //            case 0: //saisie
    //                qte += objet.data.qte
    //                break;
    //            case 1://nbadulte
    //                qte += item.nb_adulte
    //                //item.data.forEach(function (dataResaHeberg) { qte += dataResaHeberg.nb_adulte })
    //                break;
    //            case 2://nbenfant
    //                qte += item.nb_enfant
    //                //item.data.forEach(function (dataResaHeberg) { qte += dataResaHeberg.nb_enfant })
    //                break;
    //            case 3://nbadulte+nbenfant
    //                qte += item.nb_adulte + item.nb_enfant
    //                //item.data.forEach(function (dataResaHeberg) { qte += dataResaHeberg.nb_adulte + dataResaHeberg.nb_enfant })
    //                break;
    //        }
    //    })
    //    return qte
    //}
    this.mGetQuantiteParJour = function () {
        var qte = 0
        switch (parseInt(objet.data.id_type_quantite)) {
            case 0: //saisie
                qte = objet.data.qte
                break;
            case 1://nbadulte
                qte = this.mGetDataReservationHebergement().nb_adulte
                //qte = item.nb_adulte
                ////item.data.forEach(function (dataResaHeberg) { qte += dataResaHeberg.nb_adulte })
                break;
            case 2://nbenfant
                qte = this.mGetDataReservationHebergement().nb_enfant
                //qte = item.nb_enfant
                ////item.data.forEach(function (dataResaHeberg) { qte += dataResaHeberg.nb_enfant })
                break;
            case 3://nbadulte+nbenfant
                qte = this.mGetDataReservationHebergement().nb_adulte + this.mGetDataReservationHebergement().nb_enfant
                //qte = item.nb_adulte + item.nb_enfant
                ////item.data.forEach(function (dataResaHeberg) { qte += dataResaHeberg.nb_adulte + dataResaHeberg.nb_enfant })
                break;
        }
        return qte
    }
    this.mGetLibQuantiteHtml = function () {
        switch (parseInt(objet.data.id_type_quantite)) {
            case 0: //saisie
                return this.mGetQuantiteParJour() + " <i class='fas fa-barcode' title='unité'></i>";
                break;
            case 1://nbadulte
                return this.mGetQuantiteParJour() + "<i class='fas fa-person' title='adulte'></i>";
                break;
            case 2://nbenfant
                return this.mGetQuantiteParJour() + "<i class='fas fa-child-reaching' title='enfant'></i>";
                break;
            case 3://nbadulte+nbenfant
                var dataReservation = this.mGetDataReservation()
                if (dataReservation) {
                    return (this.mGetNbAdulte() > 0 ? this.mGetNbAdulte() + "<i class='fas fa-person' title='adulte'></i> " : "") + (this.mGetNbEnfant() > 0 ? this.mGetNbEnfant() + "<i class='fas fa-child-reaching' title='enfant'></i>" : "");
                } else {
                    return "0<i class='fas fa-person' title='adulte'></i> 0<i class='fas fa-child-reaching' title='enfant'></i>"
                }
                break;
        }
    }
    //this.mGetLibQuantiteTooltip = function () {
    //    switch (parseInt(objet.data.id_type_quantite)) {
    //        case 0: //saisie
    //            return this.mGetQuantiteParJour() + " unité" + (this.mGetQuantiteParJour() > 1 ? "s" : "");
    //            break;
    //        case 1://nbadulte
    //            return this.mGetQuantiteParJour() + " adulte" + (this.mGetQuantiteParJour() > 1 ? "s" : "");
    //            break;
    //        case 2://nbenfant
    //            return this.mGetQuantite() + " enfant" + (this.mGetQuantite() > 1 ? "s" : "");
    //            break;
    //        case 3://nbadulte+nbenfant
    //            return (this.mGetNbAdulte() > 0 ? this.mGetNbAdulte() + " adulte" + (this.mGetNbAdulte() > 1 ? "s" : "") : "") + (this.mGetNbEnfant() > 0 ? this.mGetNbEnfant() + " enfant" + (this.mGetNbEnfant() > 1 ? "s" : "") : "")
    //            break;
    //    }
    //}

    this.mGetTotTtc = function () {
        var lstGrpDateNbResaService = this.mGetLstGrpDateNbReservationService()
        if (lstGrpDateNbResaService.length == 0) {
            return 0
        } else {
            var totTtc = 0
            lstGrpDateNbResaService.forEach(function (objGrpDateNbResaService) {
                totTtc += objGrpDateNbResaService.mGetTotTtc()
            })
            return totTtc
        }
    }

}